/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./deliver-group-list.vue?vue&type=template&id=c7c1543c&"
import script from "./deliver-group-list.vue?vue&type=script&lang=js&"
export * from "./deliver-group-list.vue?vue&type=script&lang=js&"
import style0 from "./deliver-group-list.vue?vue&type=style&index=0&id=c7c1543c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports